<template>
	<SectionCard title="Campagne" icon="mdi-format-list-bulleted" :subtitle="subtitle" no-padding data-tour="campaigns">
		<template #actions>
			<v-text-field
				:value="search"
				dense
				outlined
				hide-details
				clearable
				prepend-inner-icon="mdi-magnify"
				placeholder="Cerca campagna"
				class="ac-search"
				@input="$emit('update:search', $event || '')"
			/>
		</template>
		<v-data-table
			:headers="headers"
			:items="items"
			:search="search"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:items-per-page="25"
			:footer-props="{ 'items-per-page-options': [25, 50, 100] }"
			dense
			class="ac-table"
		>
			<template v-slot:[`item.name`]="{ item }">
				<v-avatar size="16" tile class="mr-1"><img :src="info(item.source).logo" :alt="info(item.source).label" /></v-avatar>
				{{ item.name || item.campaignId }}
				<v-chip v-if="status(item.status)" x-small label outlined :color="status(item.status).color" class="ml-1">{{ status(item.status).label }}</v-chip>
			</template>
			<template v-slot:[`item.spend`]="{ item }">{{ formatEurCents(item.spend) }}</template>
			<template v-slot:[`item.clicks`]="{ item }">{{ formatNumber(item.clicks) }}</template>
			<template v-slot:[`item.cpc`]="{ item }">{{ item.cpc === null ? '—' : formatEurCents(item.cpc) }}</template>
			<template v-slot:[`item.conversions`]="{ item }">{{ formatNumber(item.conversions) }}</template>
			<template v-slot:[`item.conversionValue`]="{ item }">{{ formatEurCents(item.conversionValue) }}</template>
			<template v-slot:[`item.platformRoas`]="{ item }">
				<span :class="{ 'red--text text--darken-1 font-weight-medium': item.belowBreakeven }" :title="item.belowBreakeven ? 'Sotto il ROAS di pareggio' : ''">{{ formatRoas(item.platformRoas) }}</span>
			</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-menu offset-y left>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon small v-bind="attrs" title="Azioni" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
					</template>
					<v-list dense>
						<v-list-item link :href="info(item.source).console(item.accountId)" target="_blank">
							<v-list-item-title>Apri in {{ info(item.source).label }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<template v-slot:no-data>
				<div class="grey--text py-4">Nessuna campagna con spesa nel periodo.</div>
			</template>
		</v-data-table>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber } from '@/components/dashboard/format';
import { sourceInfo, formatRoas, CAMPAIGN_STATUS } from './labels';

export default {
	name: 'AdsCampaigns',
	components: { SectionCard },
	props: {
		items: { type: Array, default: () => [] },
		search: { type: String, default: '' },
		breakevenRoas: { type: Number, default: null },
	},
	data() {
		return {
			sortBy: 'spend',
			sortDesc: true,
			headers: [
				{ text: 'Campagna', value: 'name' },
				{ text: 'Spesa', value: 'spend', align: 'end' },
				{ text: 'Clic', value: 'clicks', align: 'end' },
				{ text: 'Costo per clic', value: 'cpc', align: 'end' },
				{ text: 'Conversioni', value: 'conversions', align: 'end' },
				{ text: 'Valore dichiarato', value: 'conversionValue', align: 'end' },
				{ text: 'ROAS dichiarato', value: 'platformRoas', align: 'end' },
				{ text: '', value: 'actions', sortable: false, width: 44 },
			],
		};
	},
	computed: {
		subtitle() {
			const below = this.items.filter(i => i.belowBreakeven).length;
			if (this.breakevenRoas === null) return `${this.items.length} con spesa`;
			return below ? `${below} sotto il ROAS di pareggio (${formatRoas(this.breakevenRoas)})` : `tutte sopra il ROAS di pareggio (${formatRoas(this.breakevenRoas)})`;
		},
	},
	methods: {
		formatEurCents,
		formatNumber,
		formatRoas,
		info: sourceInfo,
		status: s => CAMPAIGN_STATUS[s] || null,
	},
};
</script>

<style scoped>
.ac-search {
	max-width: 240px;
}
.ac-table >>> td {
	white-space: nowrap;
}
</style>
